import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Koristimo kolačiće',
    description:
      'Koristimo kolačiće i slične tehnologije za pružanje ovog iskustva. Strogo neophodni kolačići uvijek su aktivni.',
    allow_label: 'Prihvati sve kolačiće',
    reject_label: 'Samo strogo neophodni',
    settings_label: 'Postavke kolačića',
    policy_link_label: 'Pravila privatnosti i kolačića',
    categories_label: 'Kategorije',
    always_on_label: 'Uvijek aktivno',
    required_label: 'Obavezno',
    save_preferences_label: 'Spremi postavke',
    close_label: 'Zatvori',
    allow_all_optional_categories_label: 'Dopusti sve neobavezne kategorije',
    settings_title: 'Postavke kolačića',
    settings_description:
      'Koristimo kolačiće i slične tehnologije za pružanje ovog iskustva. Strogo neophodni kolačići uvijek su aktivni.',
    save_error: 'Nismo mogli spremiti vaš odabir privatnosti. Pokušajte ponovno.'
  },
  categories: {
    strictly_necessary: {
      name: 'Strogo neophodno',
      purpose: 'Neophodni su za pružanje ovog iskustva i ne mogu se isključiti.'
    },
    analytics: {
      name: 'Analitika',
      purpose: 'Mjeri kako posjetitelji koriste ovo iskustvo kako bi se poboljšale performanse.'
    },
    marketing: { name: 'Marketing', purpose: 'Podržava oglašavanje i marketing koje je odabrao organizator.' }
  }
};

export default locale;
